



















// Importing components
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheFormTowns',
    components: {
        TheTownSelect,
        BaseInputField,
        BaseButton,
        BaseLoadingAnimation,
    },
    props: {
        errors: Array,
    },
    data() {
        return {
            ekatte: String(),
        };
    },
};
